import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import UniversalLink from "./UniversalLink";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";

const NavItem = styled.div`
  text-decoration: none;
  color: #111;
  display: inline-block;
  white-space: nowrap;
  margin: 0 1vw;
  transition: all 200ms ease-in;
  position: relative;
  text-transform: uppercase;
  letter-spacing: 0.5pt;

  .current-menu-item {
    color: #f90303;

    :after {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      content: ".";
      color: transparent;
      background: #f90303;
      height: 1px;
      transition: all 0.2s ease-in;
    }
  }
  :after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 0%;
    content: ".";
    color: transparent;
    background: #f90303;
    height: 1px;
    transition: all 0.2s ease-in;
  }
  :hover {
    ::after {
      width: 100%;
    }
  }
  :focus {
    color: #f90303;
  }
  @media (max-width: 997px) {
    padding: 10px 0;
    z-index: 6;
    border-bottom: 1px solid #d3d3d3;
    width: 100%;
    text-align: center;
    margin: 0;

    .current-menu-item {
      color: #f90303;

      :after {
        width: 0%;
      }
    }
  }
`;
const Menu = () => {
  const { contentfulWebsiteHeader } = useStaticQuery(graphql`
    {
      contentfulWebsiteHeader(
        id: { eq: "303af5df-aec1-5121-9ea0-8e74d845caee" }
      ) {
        id
        logo {
          gatsbyImage(width: 150, quality: 70, placeholder: NONE)
        }
        navItems {
          id
          linkRoute
          linkText
          linkType
        }
      }
    }
  `);

  if (
    !contentfulWebsiteHeader?.navItems ||
    contentfulWebsiteHeader?.navItems?.length === 0
  )
    return null;

  return (
    <nav
      className="primary-menu-wrapper"
      aria-label="Horizontal"
      role="navigation"
    >
      <div className="primary-menu reset-list-style">
        {contentfulWebsiteHeader.navItems.map((menuItem, i) => {
          const path = menuItem?.linkRoute;
          const itemId = "menu-item-" + menuItem.id;
          return (
            <NavItem
              id={itemId}
              key={i + menuItem.url}
              className={
                "menu-item menu-item-type-custom menu-item-object-custom menu-item-home " +
                itemId
              }
            >
              <GatsbyLink
                to={`${path === "/" ? "/" : `/${path}/`}`}
                activeClassName="current-menu-item current_page_item"
              >
                {menuItem.linkText}
              </GatsbyLink>
            </NavItem>
          );
        })}
      </div>
    </nav>
  );
};

export default Menu;
